import { render, staticRenderFns } from "./FloatBottom.vue?vue&type=template&id=6d25b9f6&scoped=true&"
import script from "./FloatBottom.vue?vue&type=script&lang=ts&"
export * from "./FloatBottom.vue?vue&type=script&lang=ts&"
import style0 from "./FloatBottom.vue?vue&type=style&index=0&id=6d25b9f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d25b9f6",
  null
  
)

export default component.exports